import { Typography } from "antd";
import { DATE_TIME_FORMAT3 } from "config/constants";
import moment from "moment";
import { formatDateTime } from "utils/dateTime";

const DeliveryDeadline = ({
  deliveryDeadline,
  expectedDeliveryFrom,
  expectedDeliveryTo,
  statusCheck,
  timeCheck,
  strong = false,
}) => {
  const deadlineMoment = moment(deliveryDeadline);

  if (deliveryDeadline) {
    const resolveTextWarning = () => {
      const diffMs = deadlineMoment - timeCheck;

      const diffMinutes = diffMs / 1000 / 60;
      const hours = diffMinutes < 0 ? Math.floor(diffMinutes / 60) : Math.ceil(diffMinutes / 60);

      if (hours >= 24) {
        const days = Math.floor(hours / 24);
        return !statusCheck && `(Còn lại ${days} ngày)`;
      } else if (hours >= 0) {
        return !statusCheck && `(Còn lại ${hours} giờ)`;
      } else if (hours >= -24) {
        return `(Quá hạn ${Math.abs(hours)} giờ)`;
      } else {
        const days = Math.floor(Math.abs(hours) / 24);
        return `(Quá hạn ${days} ngày)`;
      }
    };

    const resolveTextColor = (deadline, now = new Date()) => {
      const diffMs = deadline - now;
      const diffMinutes = diffMs / 1000 / 60;
      const hours = diffMinutes < 0 ? Math.floor(diffMinutes / 60) : Math.ceil(diffMinutes / 60);

      if (hours >= 24) {
        return "#00ab78";
      } else if (hours >= 0) {
        return "#EF9351";
      } else {
        return "#D2434D";
      }
    };

    return (
      <div>
        <Typography.Text strong={strong} style={{ color: "#052987" }}>
          {formatDateTime(deliveryDeadline, DATE_TIME_FORMAT3)}
        </Typography.Text>
        <br />
        <Typography.Text strong={strong} style={{ color: resolveTextColor() }}>
          {resolveTextWarning()}
        </Typography.Text>
      </div>
    );
  }

  if (expectedDeliveryFrom && expectedDeliveryTo) {
    return (
      <Typography.Text strong={strong} style={{ color: "#052987" }}>
        {formatDateTime(expectedDeliveryFrom, "DD/MM/YYYY")} - {formatDateTime(expectedDeliveryTo, "DD/MM/YYYY")}
      </Typography.Text>
    );
  }

  return <Typography.Text strong={strong} italic>{`<Không yêu cầu thời gian>`}</Typography.Text>;
};

export default DeliveryDeadline;
